import ROUTE_NAMES from '@/assets/src/routes';

export default {
  path: '/console/',
  name: 'console',
  component: () => import(/* webpackChunkName: "ConsoleView" */ '@/views/ConsoleView.vue'),
  children: [
    {
      path: 'user',
      name: ROUTE_NAMES.FIND_USER,
      component: () => import(/* webpackChunkName: "ConsoleView" */ '@/views/console/FindUser.vue'),
    },
    {
      path: 'inspectuser/:cognito_id/',
      name: ROUTE_NAMES.INSPECT_USER,
      component: () => import(/* webpackChunkName: "ConsoleView" */ '@/views/console/InspectUser.vue'),
    },
    {
      path: 'feedback',
      name: ROUTE_NAMES.FEEDBACK,
      component: () => import(/* webpackChunkName: "ConsoleView" */ '@/views/console/ListFeedback.vue'),
    },
    {
      path: 'coupons',
      name: ROUTE_NAMES.COUPONS,
      component: () => import(/* webpackChunkName: "ConsoleView" */ '@/views/console/ListCoupons.vue'),
    },
    {
      path: 'faileddemos',
      name: ROUTE_NAMES.FAILED_DEMOS,
      component: () => import(/* webpackChunkName: "ConsoleView" */ '@/views/console/ListFailedDemos.vue'),
    },
  ],
};
